// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2BqdH","header":"Messages_header__ZhxJp"};